import type { InputHTMLAttributes } from "react";

import classNames from "classnames";

import styles from "./Input.module.css";

type InputProps = InputHTMLAttributes<HTMLInputElement>;

export function Input({ children, className, type = "text", ...props }: InputProps) {
    return <input {...props} className={classNames(styles.input, className)} type={type} />;
}
